import React from 'react';
import PanelMeasure from '@/layout/components/PanelMeasure';
import SubscribersPanelFull from './SubscribersPanelFull';
import SubscribersPanelNarrow from './SubscribersPanelNarrow';

const SubscribersPanel = ({ configuration, onChange }) => (
  <PanelMeasure
    configuration={configuration}
    component={{ full: SubscribersPanelFull, narrow: SubscribersPanelNarrow }}
    onChange={onChange}
    width={620}
  />
);

export default SubscribersPanel;
